import type { PopmenuTheme } from '~/utils/withTheme';

export const styles = () => ({
  img: {
    transition: '0.6s filter linear',
  },
  photo: (popmenuTheme: PopmenuTheme | null | undefined) => {
    if (!popmenuTheme?.photoStyles) return {};

    return {
      border: popmenuTheme.photoStyles.border,
      borderRadius: popmenuTheme.photoStyles.borderRadius,
      boxShadow: popmenuTheme.photoStyles.boxShadow,
    };
  },
});
